import React from 'react'
import ReactDOM from 'react-dom'
import {Map, Marker} from 'google-maps-react'
import ResultItem from './ResultItem'

const style = {
  width: '100%',
  height: '100%',
}



class MapView extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedResult: 0,
      bounds: null,
      overlay: null,
      map: null,
      selectedMarkerPos: {x: 0, y: 0},
    }

    this.selectedResRef = React.createRef()
    this.mapRef = React.createRef()
  }

  makeBounds = (results, resultsById) => {
    const bounds = new window.google.maps.LatLngBounds()
    results.forEach(res => {
      bounds.extend({
        lat: resultsById[res].lat,
        lng: resultsById[res].lng
      })
    })
    this.setState({
      ...this.state,
      bounds,
    })
  }

  componentDidMount() {
    // update the maps initial zoom and center to fit the bounds
    this.makeBounds(this.props.results, this.props.resultsById)
  }

  componentWillReceiveProps(nextProps) {
    // update the bounds when the new results come through so the map zoom etc is re-rendered
    this.makeBounds(nextProps.results, nextProps.resultsById)
  }

  componentDidUpdate() {
    // watch for the rendered element and make sure that it's not outside the bounds
    if (!this.selectedResRef.current || !this.mapRef.current || this.state.selectedMarkerPos.manual) return
    const el = ReactDOM.findDOMNode(this.selectedResRef.current)
    const map = this.mapRef.current

    var style = window.getComputedStyle ? getComputedStyle(map, null) : map.currentStyle;
    const mapHeight = map.offsetHeight

    const width = el.offsetWidth
    const height = el.offsetHeight
    const halfWidth = width / 2

    // find the best position for this element
    const {x, y} = this.state.selectedMarkerPos

    // try and center
    let left = x - halfWidth
    if (left < 0) {
      // if that's too far left, set it to be hard left
      left = x
    } else if (left + halfWidth > map.offsetWidth) {
      // if that's too far right, set it to be hard right
      left = map.offsetWidth - width
    }

    // do the same for the height
    // but the item should sit on top the pin, so remove the full height
    let top = y - height
    if (top < 0) {
      top = 0 + parseInt(style.paddingTop, 10)
    } else if (top + height > mapHeight) {
      top = mapHeight - height
    }
    this.setState({
      ...this.state,
      selectedMarkerPos: {
        x: left,
        y: top,
        manual: true,
      }
    })
  }

  renderMarkers = () => {
    return this.props.results.map(res => {
      return (
        <Marker
          position={{lat: this.props.resultsById[res].lat, lng: this.props.resultsById[res].lng}}
          key={`property-marker-${res}`}
          icon={{
            url: this.props.strings.marker_image,
            scaledSize: new window.google.maps.Size(35, 50.3),
          }}
          onClick={(props, marker, e) => this.setSelectedResult(res, e)} />
      )
    })
  }

  setSelectedResult = (resultId, e) => {
// https://developers.google.com/maps/documentation/javascript/reference/overlay-view#MapCanvasProjection.fromLatLngToDivPixel
    const markerPos = this.state.overlay.getProjection().fromLatLngToContainerPixel(e.latLng)
    this.setState({
      ...this.state,
      selectedResult: resultId,
      selectedMarkerPos: {
        x: markerPos.x,
        y: markerPos.y,
      }
    })
  }

  closeSelectedResult = () => {
    this.setState({
      ...this.state,
      selectedResult: 0,
      selectedMarkerPos: {x: 0, y: 0},
    })
  }

  renderSelectedResult = () => {
    if (!this.state.selectedResult) return null
    return (
      <div className="gw-search__map-selected-result" style={{left: this.state.selectedMarkerPos.x, top: this.state.selectedMarkerPos.y}}>
        <div className="gw-search__map-selected-result-close" onClick={this.closeSelectedResult}>
          <span className="icon-plus" />
        </div>
        <ResultItem
          property={this.props.resultsById[this.state.selectedResult]}
          strings={this.props.strings}
          supportsMixBlendMode={this.props.supportsMixBlendMode}
          swiperItem={false}
          fieldsToRemove={this.props.fieldsToRemove}
          ref={this.selectedResRef} />
      </div>
    )
  }

  onOverlayChange = () => {
    const overlay = new window.google.maps.OverlayView()
    overlay.draw = function() {}
    overlay.setMap(this.state.map)
    this.setState({
      ...this.state,
      overlay,
    })
  }

  onReady = (props, map) => {
    this.setState({
      ...this.state,
      map,
    })
    this.onOverlayChange()
  }

  render() {
    if (!window.google || !window.google.maps) return 'Google maps is not installed'
    return (
      <div className="gw-search__map-view" ref={this.mapRef}>
        <div className="gw-search__map-overlay"></div>
        <div className="gw-search__map-content">
          <Map
            onReady={this.onReady}
            onClick={this.closeSelectedResult}
            google={window.google}
            zoom={14}
            style={style}
            bounds={this.state.bounds}
            initialCenter={{lat: -36.844695, lng: 174.766532}}
            onOverlayChange={this.onOverlayChange}
            mapTypeControl={false}
            streetViewControl={false}
            fullscreenControl={false}>
            {this.renderMarkers()}
          </Map>
        </div>
        {this.renderSelectedResult()}
      </div>
    )
  }
}


export default MapView



// WEBPACK FOOTER //
// ./src/components/results/MapView.js